<template>
  <svg
    width="16"
    height="6"
    viewBox="0 0 16 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 0H0V2H16V0ZM0 6H16V4H0V6Z"
      fill="#080816"
      fill-opacity="0.54"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
